module.exports = __webpack_public_path__ + "static/media/escolhaUnica.cba7355b.jpg";